// صفحة مهام ساره - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const SaraTasks = () => (
  <EmployeeTasksPage employeeName="ساره" title="ساره" backPath="/sara" />
);

export default SaraTasks;
